import Result from './Result.vue';

export * from './types';
export default Result;



// WEBPACK FOOTER //
// ./src/pages/profile/components/info/components/block/components/result/index.ts